import { Link } from "react-router-dom";
import { ARTICLES } from "../data/articles";
import { Reveal } from "../components/Reveal";
import { JournalArchive } from "../components/JournalArchive";

const Byline = ({ a, light }) => (
  <p className={`text-[10px] uppercase tracking-[0.28em] ${light ? "text-neutral-400" : "text-neutral-500"}`}>
    By {a.author} <span className="mx-2">·</span> {a.date} <span className="mx-2">·</span> {a.read}
  </p>
);

export const JournalCard = ({ a }) => (
  <Link to={`/blog/${a.slug}`} className="group block min-w-0" data-testid={`journal-card-${a.slug}`}>
    <div className="aspect-[4/3] overflow-hidden bg-neutral-100">{a.image && <img src={a.image} alt={a.title} className="img-zoom h-full w-full object-cover" loading="lazy" />}</div>
    <p className="mt-6 text-[10px] font-semibold uppercase tracking-[0.35em] text-neutral-950">{a.category}</p>
    <h3 className="font-vogue mt-3 break-words text-3xl leading-tight text-neutral-950 transition-colors group-hover:text-neutral-500 md:text-4xl">{a.title}</h3>
    <p className="mt-4 text-sm font-light leading-relaxed text-neutral-600">{a.dek}</p>
    <div className="mt-5"><Byline a={a} /></div>
  </Link>
);

export default function Blog() {
  const [lead, ...rest] = ARTICLES;
  return (
    <main className="bg-white" data-testid="blog-page">
      <section className="border-b border-neutral-950 px-4 pb-10 pt-16 text-center md:pt-24">
        <p className="text-[10px] uppercase tracking-[0.45em] text-neutral-500">Lux Veritae Skin Spa</p>
        <h1 className="font-vogue mt-4 text-6xl leading-none tracking-tight text-neutral-950 sm:text-7xl lg:text-[9rem]" data-testid="journal-masthead">The Journal</h1>
        <p className="font-display mt-6 text-xl italic text-neutral-600">Confident enough to leave the lights on.</p>
      </section>

      <section className="mx-auto max-w-[1400px] px-4 py-16 md:px-8 md:py-24">
        <Link to={`/blog/${lead.slug}`} className="group grid items-center gap-10 lg:grid-cols-[1.4fr_1fr] lg:gap-16" data-testid="journal-lead-story">
          <div className="aspect-[16/11] overflow-hidden bg-neutral-100"><img src={lead.image} alt={lead.title} className="img-zoom h-full w-full object-cover" /></div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.35em] text-neutral-950">The Cover Story · {lead.category}</p>
            <h2 className="font-vogue mt-5 text-5xl leading-[1.02] text-neutral-950 md:text-6xl">{lead.title}</h2>
            <p className="font-display mt-6 text-2xl font-light italic leading-snug text-neutral-600">{lead.dek}</p>
            <div className="mt-8"><Byline a={lead} /></div>
            <span className="link-under mt-10">Read the Story</span>
          </div>
        </Link>
      </section>

      {rest.length > 0 && (
        <section className="border-t border-neutral-200 bg-[hsl(var(--stone))] py-20 md:py-28">
          <div className="mx-auto max-w-[1400px] px-4 md:px-8">
            <p className="mb-12 text-center text-[10px] uppercase tracking-[0.45em] text-neutral-500">Latest</p>
            <div className="grid gap-14 md:grid-cols-2 lg:grid-cols-3">
              {rest.map((a) => <Reveal key={a.slug}><JournalCard a={a} /></Reveal>)}
            </div>
          </div>
        </section>
      )}
      <JournalArchive />
    </main>
  );
}
